import { CompatibleRoomConfiguration } from 'utilities/roomConfigurationHelpers';

interface RoomConfigurationDisplayProps {
  configurations: CompatibleRoomConfiguration[];
  roomType?: string;
}

const RoomConfigurationDisplay = ({
  configurations,
}: RoomConfigurationDisplayProps) => {
  if (!configurations || configurations.length === 0) {
    return <span className="text-base font-medium text-gray-900">0</span>;
  }

  const totalRooms = configurations.reduce(
    (sum, config) => sum + config.rooms,
    0,
  );

  // Format configuration details
  const configDetails = configurations.map((config, index) => {
    const guestText = config.guests === 1 ? 'guest' : 'guests';
    const roomText = config.rooms === 1 ? 'room' : 'rooms';
    return (
      <span key={index} className="block">
        {config.rooms} {roomText} ({config.guests} {guestText} each)
      </span>
    );
  });

  return (
    <div className="space-y-1">
      <span className="text-base font-medium text-gray-900">
        {totalRooms} total
      </span>
      <div className="mt-1 text-sm text-gray-600">{configDetails}</div>
    </div>
  );
};

export default RoomConfigurationDisplay;
